"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Switch: function() {
        return _Switch.Switch;
    },
    renderSwitch_unstable: function() {
        return _Switch.renderSwitch_unstable;
    },
    switchClassName: function() {
        return _Switch.switchClassName;
    },
    switchClassNames: function() {
        return _Switch.switchClassNames;
    },
    useSwitchStyles_unstable: function() {
        return _Switch.useSwitchStyles_unstable;
    },
    useSwitch_unstable: function() {
        return _Switch.useSwitch_unstable;
    }
});
const _Switch = require("./Switch");
